import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SitePopup = ({ open, onClose }) => {
  const handleBuyClick = () => {
    window.open('https://www.tanyaegyetemwebshop.hu', '_blank');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      {/* Fejléc kis X ikon gombbal */}
      <DialogTitle
        sx={{ m: 0, p: 2, position: 'relative', textAlign: 'center' }}
      >
        <Typography variant='h4' gutterBottom>
          Újra elérhető
        </Typography>
        <Typography variant='h4'>
          a Fenntartható visszafejlődés könyvsorozat!
        </Typography>
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[100],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', px: 3, pt: 0 }}>
        <Typography variant='body1' gutterBottom>
          Kattints a webshopra, hogy teljes legyen a trilógia a polcodon!
        </Typography>

        {/* Nagy kép középen */}
        <Box sx={{ my: 2 }}>
          <img
            src='./img/books/konyvek.jpg'
            alt='Három könyv'
            style={{ maxWidth: '100%', height: 'auto', borderRadius: 8 }}
          />
        </Box>

        {/* Három kis könyv egymás mellett */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            my: 2,
            flexWrap: 'wrap',
          }}
        >
          <img
            src='./img/books/fent1.jpg'
            alt='Könyv 1'
            style={{ width: 100, height: 'auto', borderRadius: 4 }}
          />
          <img
            src='./img/books/fent2.jpg'
            alt='Könyv 2'
            style={{ width: 100, height: 'auto', borderRadius: 4 }}
          />
          <img
            src='./img/books/uvszab.jpg'
            alt='Könyv 3'
            style={{ width: 100, height: 'auto', borderRadius: 4 }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
        <Button onClick={onClose} variant='contained' color='secondary'>
          Bezárás
        </Button>
        <Button onClick={handleBuyClick} variant='contained' color='primary'>
          Irány a webshop!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SitePopup;
